import $ from 'jquery';

function Component({template, data = {}}) {
  this.data = data;
  this.setTemplate(template);
  this.eventTargets = [];
  this.$html = null;
}

Component.prototype = {
  addEventListener(target, etype, callback) {
    this.eventTargets.push({target, callback, etype});
    this.$html.on(etype, target, callback);
  },

  setTemplate(jsrenderTemplateString) {
    if (!jsrenderTemplateString) {
      return;
    }
    this.template = $.templates(jsrenderTemplateString);
  },

  /**
   * 컴포넌트가 받은 데이터를 render 함수로 전달할 때 실행된다.
   * 컴포넌트에 내려오는 데이터 포맷을 템플릿에 필요한 포맷으로 변형하려면 오버라이딩 해서 사용한다
   * 템플릿에 데이터가 내려간다면 리턴값은 무조건 존재해야한다.
   * @param data
   * @returns {*}
   */
  toTemplateDataFormat(data) {
    return data;
  },

  render() {
    this.destroy();
    this.beforeRender();
    this.html = this._render(this.toTemplateDataFormat(this.data));
    this.$html = $(this.html);
    this.afterRender();

    return this.$html.get(0);
  },

  beforeDestroy() {},

  afterRender() {},

  beforeRender() {},

  _unbindComponentEvents() {
    $.each(this.eventTargets, (idx, { target, etype, callback }) => {
      this.$html.off(etype, target, callback);
    });
  },

  _render(data) {
    return this.template.render(data);
  },

  destroy() {
    this.beforeDestroy();
    this._unbindComponentEvents();
    if (this.$html) {
      this.$html.remove();
    }
  },

  getElement(query) {
    return this.$html.find(query);
  }
};

export default Component;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/component.js
 **/